import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface ClearEmailVerificationForAllConcernResponse extends BackendResponse {}
export interface ClearEmailVerificationForAllConcernParameters extends NextApiParams {}

export const clearEmailVerificationForAllConcern = withNextApi<
  ClearEmailVerificationForAllConcernResponse,
  ClearEmailVerificationForAllConcernParameters
>("/cvp/CvpClearEmailVerificationForAllConcern");
